import { useRouter } from 'next/router';
import { GetServerSideProps, NextPage } from 'next/types';
import React from 'react';

import { getUrlWithHost } from '@/helpers/url';
import { envVars } from '@/services/ApiService';
import { getCommonServerSideProps } from '@/util/getServerSideProps';
import { resolveUrlWithHostSsr } from '@/util/resolvePortalHost';
import AccessConsume from '@/wrappers/auth/AccessConsume';
import LayoutConsume from '@/wrappers/layout/LayoutConsume';

import { Role } from '../models/authModels';

const Index: NextPage = () => {
  const router = useRouter();

  React.useEffect(() => {
    window.location.href = getUrlWithHost('/app', envVars.checkHost);
  }, [router]);

  return (
    <div className="container">
      <AccessConsume roles={[Role.admin]}>
        <LayoutConsume menuActive={false}>
          <></>
        </LayoutConsume>
      </AccessConsume>
    </div>
  );
};

export default Index;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const commonProps = await getCommonServerSideProps(context);
  const host = commonProps.host;
  const company = commonProps.company;

  if (company?.portal_v3_access && !company.portal_registration_access && !commonProps.user) {
    return {
      redirect: {
        destination: resolveUrlWithHostSsr('/login', envVars.checkHost, context),
        permanent: false,
      },
    };
  }

  return {
    props: {
      ...commonProps,
    },
  };
};
